<template>
  <!-- Info Section -->
  <section class="info-section">
    <h2 class="info-title">{{ locale === 'tr' ? 'Evinizi Güneş Enerjisiyle Güçlendirin' : 'Power Your Home with Solar Energy' }}</h2>
    <div class="info-cards">
      <div 
        class="info-card"
        :class="card.type"
        v-for="card in infoCards" 
        :key="card.id"
        :style="card.backgroundImage ? { backgroundImage: `url(${card.backgroundImage})` } : {}"
      >
        <h3>{{ card.title }}</h3>
        <p>{{ card.description }}</p>
        <button class="info-btn">{{ card.buttonText }}</button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useInfoSection } from '@/composables/useInfoSection'

// Props
const props = defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Create computed locale ref for reactivity
const localeRef = computed(() => props.locale)

// Composable kullanımı
const { infoCards } = useInfoSection(localeRef)
</script>